import { siteConfig } from './site'

export type ConsentChoice = 'accepted' | 'rejected'

export const CONSENT_STORAGE_KEY = 'fm-cookie-consent'
export const CONSENT_CHANGE_EVENT = 'fm-cookie-consent-change'

const optionalStorageKeys = [siteConfig.theme.storageKey]

export function readConsentChoice(): ConsentChoice | null {
  if (typeof window === 'undefined') return null

  try {
    const stored = window.localStorage.getItem(CONSENT_STORAGE_KEY)
    return stored === 'accepted' || stored === 'rejected' ? stored : null
  } catch {
    return null
  }
}

export function allowsOptionalStorage() {
  return readConsentChoice() === 'accepted'
}

export function clearOptionalStorage() {
  if (typeof window === 'undefined') return

  for (const key of optionalStorageKeys) {
    try {
      window.localStorage.removeItem(key)
      window.sessionStorage.removeItem(key)
    } catch {
      // Storage can be unavailable in privacy-focused browser modes.
    }
  }
}

export function saveConsentChoice(choice: ConsentChoice) {
  if (typeof window === 'undefined') return

  if (choice === 'rejected') clearOptionalStorage()

  try {
    // The consent decision is essential storage: it prevents repeated prompts.
    window.localStorage.setItem(CONSENT_STORAGE_KEY, choice)
  } catch {
    // If essential storage is blocked, the banner will reappear next visit.
  }

  window.dispatchEvent(new CustomEvent<ConsentChoice>(CONSENT_CHANGE_EVENT, { detail: choice }))
}
